module.exports = __webpack_public_path__ + "static/img/appdownload.b218f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appdownload.png
// module id = 155
// module chunks = 1